import styled from 'styled-components';

export const StyledStatus = styled.div`
    display: flex;
  
  .in-progress {
    fill: ${props => props.theme.colors.primary} !important;
  }
`;
